import { Button, ErrorMessage } from "components";
import { useModifiedTranslation } from "hooks/useModifiedTranslation";
import { keycloakService } from "services/keycloakService";

export const NoOnboardingProcess = () => {
  const { t } = useModifiedTranslation();
  return (
    <ErrorMessage
      header={t("missingLinkedContactPage.noOnboardingProcessHeader")}
    >
      {t("missingLinkedContactPage.noOnboardingProcessMessage")}
      <div className="py-4">
        <Button onClick={() => keycloakService.onAuthLogout()}>
          {t("userMenu.logout")}
        </Button>
      </div>
    </ErrorMessage>
  );
};
